import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = ()=> {
  return  {
    categories: [],
    services: [],
    availableServices: [],
    providerCategories: [],
    providerServices: []
  }
}

export default {
  namespaced: true,
  state: {
    categories: [],
    services: [],
    availableServices: [],
    providerCategories: [],
    providerServices: []
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setServices(state, payload) {
      state.services = payload
    },
    setCategories(state, payload) {
      state.categories = payload
    },
    setProviderServices(state, payload) {
      state.providerServices = payload
    },
    setAvailableServices(state, payload) {
      state.availableServices = payload
    },
    setProviderCategories(state, payload) {
      state.providerCategories = payload
    },
    addProviderCategory(state, payload) {
      state.providerCategories.push(payload)
      state.categories.push(payload)
    },
    addProviderService(state, payload) {
      state.providerServices.push(payload)
      state.services.push(payload)
    },
    removeServiceById(state, payload) {
      const index = state.providerServices.findIndex(sel => sel.serviceItemId === payload)
      state.providerServices.splice(index, 1)
    }
  },
  actions: {
    async loadProviderServices(ctx) {
      const userId = ctx.rootState.currentProvider.id
      const response = await ApiUtils.makeGet(`provider/${userId}/services/attached`)
      const data = await response.json()
      const filtered = categoriesAndServices(data, false)
      ctx.commit('setProviderCategories', filtered.categories)
      ctx.commit('setProviderServices', filtered.services)
    },
    async loadServices(ctx) {
      await ctx.dispatch('loadProviderServices')
      const userId = ctx.rootState.currentProvider.id
      const response = await ApiUtils.makeGet(`provider/${userId}/services/available`)
      const data = await response.json()
      const filtered = categoriesAndServices(data, true)
      ctx.commit('setCategories', filtered.categories)
      ctx.commit('setServices', filtered.services)
      ctx.commit('setAvailableServices', data.result.services)

    }
  },
  getters: {
    categories: state => state.categories,
    services: state => state.services,
    availableServices: state => state.availableServices,
    servicesByCategory: state => id => {
      const all = []
      state.services.forEach(service => {
        if (service.categoryId === id) {
          all.push(service)
        }
      })
      return all
    },
    providerCategories: state => state.providerCategories,
    providerServices: state => state.providerServices,
    providerServicesByCategory: state => id => {
      const all = []
      state.providerServices.forEach(service => {
        if (service.categoryId === id) {
          all.push(service)
        }
      })
      return all
    }
  },
}

function categoriesAndServices(data, isGeneralList) {
  const allCategories = []
  const allServices = []
  data.result.services.forEach(category => {
    if (isGeneralList)
      allCategories.push({name: category.name, categoryId: category.id})
    else if (!isGeneralList && category.service_items.length > 0)
      allCategories.push({name: category.name, categoryId: category.id})
    category.service_items.forEach(item => {
      const data = {
        categoryName: category.name,
        categoryId: category.id,
        serviceItem: item.description,
        serviceItemId: item.id,
        price: item.price || 0,
        quotable: item.quotable || 0,
        taxFree: item.tax_free || 0,
        type: item.type || 'other',
        schedulable: item.schedulable || 0,
        reviewed: item.reviewed || 0
      }
      allServices.push(data)
    })
  })
  return {
    categories: allCategories,
    services: allServices
  }
}